import { useQuery } from '@tanstack/react-query';
import { useSelector } from 'react-redux';

import { makeAPIRequestReactQuery } from './api';
import { endpoints } from './endpoints';

export interface GetPatientImageStatusesRequest {
  externalPatientId?: string;
  videaPatientId?: string;
}

export interface ImageStatus {
  acquiredDate: string;
  pending: number;
  completed: number;
  total: number;
  estimatedVisitId?: number;
}

export interface GetPatientImageStatusesResponse {
  imageStatuses: ImageStatus[];
  videaPatientId: string;
}

export const useGetPatientImageStatuses = (
  request?: GetPatientImageStatusesRequest,
) => {
  const {
    primaryPracticeId: currentPractice,
    primaryOrganizationId: currentOrg,
  } = useSelector(
    (state: {
      login: {
        user: {
          primaryPracticeId?: string;
          primaryOrganizationId?: string;
        };
      };
    }) => state.login.user,
  );

  const path = `patient/image-statuses`;

  return useQuery({
    queryKey: [endpoints.imageStatuses, request, currentPractice],
    queryFn: async () => {
      const resp =
        await makeAPIRequestReactQuery<GetPatientImageStatusesResponse>(
          path,
          request,
          'GET',
          {
            headers: {
              practice: currentPractice,
              org: currentOrg,
            },
          },
        );
      return resp;
    },
    enabled:
      Boolean(request?.externalPatientId || request?.videaPatientId) &&
      Boolean(currentPractice && currentOrg),
    staleTime: 5 * 1000, // 5 seconds
    refetchInterval: 10 * 1000, // Refetch every 10 seconds to check for updates
  });
};
